// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"c69c10ac","803":"9bf781bb"}[chunkId] + ".chunk.js";
};